import cn from 'classnames';
import React, { useRef } from 'react';

import * as styles from '@/styles/text-3d.module.css';
// import FloatingShape from '@/components/floatingShape';
import { link2048evm, slogan } from '@/utils/const';

import Text3d from './Text3D';

export function SectionFirstScreen() {
  const plane = useRef<HTMLDivElement>(null);
  const maxRotate = 45;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const manageMouseMove = (e: any) => {
    const x = e.clientX / window.innerWidth;
    const y = e.clientY / window.innerHeight;
    const perspective = window.innerWidth * 4;
    const rotateX = maxRotate * x - maxRotate / 2;
    const rotateY = (maxRotate * y - maxRotate / 2) * -1;
    if (plane.current) {
      plane.current.style.transform = `perspective(${perspective}px) rotateX(${rotateY}deg) rotateY(${rotateX}deg)`;
    }
  };

  const handleMouseLeave = () => {
    if (plane.current) {
      plane.current.style.transform = ``;
    }
  };
  return (
    <div className="relative h-[100vh] w-full sm:h-[120vh]">
      {/* <FloatingShape /> */}
      <div
        className={cn(
          'absolute left-0 top-0 flex h-full w-full flex-col items-center justify-center bg-[url("/firstScreenBg.png")] bg-cover bg-[center_top] px-4 text-center sm:px-8 lg:px-[54px]'
        )}
      >
        <div className="mb-[28px] max-w-[899px] text-[18px] leading-[26px] text-[#E2E3FF] md:mb-[40px] md:text-[28px] md:leading-[40px]">
          <div>Unleash the Fun, Mint Your Game</div>
        </div>
        <div
          onMouseMove={manageMouseMove}
          onMouseLeave={handleMouseLeave}
          className="relative hidden h-[160px] w-full justify-center md:flex"
        >
          <div ref={plane} className={styles.body}>
            <Text3d primary={slogan} secondary={slogan} />
          </div>
        </div>

        <div className="block text-[40px] md:hidden">{slogan}</div>

        <a href={link2048evm} target="_blank">
          <button
            type="button"
            className={cn(
              'mt-[50px] rounded-[10px] bg-gradient-to-r from-[#FF30D5] to-[#2E32FF] px-12 py-3 text-xl leading-[28px] text-[#FFFFFF] duration-200 hover:opacity-75 sm:mb-[10vh] sm:mt-[80px] md:px-[80px] md:text-3xl md:leading-[36px] lg:mt-[50px]'
            )}
          >
            <span>Mint & Play Now</span>
          </button>
        </a>
      </div>
    </div>
  );
}
